module.exports = __webpack_public_path__ + "img/prod-icon1.e42a48c7.png";